import { render, staticRenderFns } from "./UcHeader.yaml?vue&type=template&id=fab0abb4&component"
import script from "./UcHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports